import { useTheme } from 'next-themes'
import { Toaster } from 'sonner'

const Toast = () => {
  const { resolvedTheme } = useTheme()

  return <Toaster position="bottom-center" theme={resolvedTheme === 'dark' ? 'light' : 'dark'} />
}

export default Toast
